export default class SaveProductDiscountRequest {
    public discountId: string | null = null;
    public categoryId: string | null = null;
    public productId: string | null = null;
    public discountPercentage: number = 0;
}